module.exports = __webpack_public_path__ + "static/media/purchase-order-form_2021 EUR_price.46534146.pdf";